var _defs, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path31, _path32, _path33, _path34, _path35, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path36, _path37, _path38, _path39, _path40, _path41, _polygon2, _polygon3, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _polygon4, _polygon5, _path56;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducationDarkb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 406,
    height: 306,
    viewBox: "0 0 808.63 597.63",
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 700.64,
    y1: 267.79,
    x2: 762.75,
    y2: 362.44,
    gradientTransform: "translate(-1.42 -170.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 353.09,
    y1: 511.1,
    x2: 354.86,
    y2: 350.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 413.7,
    y1: 380.52,
    x2: 330.46,
    y2: 580.75,
    gradientTransform: "translate(-1.42 -170.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#00272e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69b9eb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 291.7,
    y1: 108.76,
    x2: 295.07,
    y2: -8.65,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 600)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 296.84,
    y1: 555.27,
    x2: 291.53,
    y2: 621.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 510.9,
    y1: 132.84,
    x2: 310.72,
    y2: 140.44,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 549.01,
    y1: 573.65,
    x2: 583.37,
    y2: 211.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 560.94,
    y1: 508.86,
    x2: 421.25,
    y2: 497.35,
    gradientTransform: "translate(-1.42 -170.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 428.28,
    y1: 503.09,
    x2: 57.02,
    y2: 503.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 549.28,
    y1: 557.46,
    x2: 551.89,
    y2: 557.46,
    gradientTransform: "translate(-1.42 -170.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69b9eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 553.11,
    y1: 461.29,
    x2: 554.51,
    y2: 461.29,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 557.44,
    y1: 468.86,
    x2: 557.9,
    y2: 468.86,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 166.75,
    y1: 736.16,
    x2: 201.12,
    y2: 526.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 195.66,
    y1: 625.77,
    x2: 201.86,
    y2: 1.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 301.88,
    y1: 507.15,
    x2: 278.8,
    y2: 505.24,
    gradientTransform: "translate(0 -170)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1030.48,
    y1: -473.84,
    x2: 1007.74,
    y2: -475.71,
    gradientTransform: "translate(-327.44 1239.03) rotate(-26.82)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 415.22,
    y1: 471.15,
    x2: 398.89,
    y2: 471.34,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 600)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 405.36,
    y1: 478.04,
    x2: 360.88,
    y2: 459.31,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 600)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 425.28,
    y1: 503.57,
    x2: 388.4,
    y2: 499.06,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 600)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 367.48,
    y1: 387.64,
    x2: 403.35,
    y2: 387.64,
    gradientTransform: "translate(-1.42 -170.05)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 330.69,
    y1: 348.29,
    x2: 338.81,
    y2: 348.29,
    gradientTransform: "translate(-1.42 -170.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 314.8,
    y1: 335.09,
    x2: 338.64,
    y2: 335.09,
    gradientTransform: "translate(-1.42 -170.05)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 327.09,
    y1: 312.14,
    x2: 375.33,
    y2: 428.79,
    gradientTransform: "translate(0 -170)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 314.79,
    y1: 335.09,
    x2: 330.75,
    y2: 335.09,
    gradientTransform: "translate(-1.42 -170.05)",
    xlinkHref: "#linear-gradient-15"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "book_lover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M293.09,43.6c-21.25,19.69-37,45-59.58,63.11-38.18,30.68-90,36.78-134.9,56.31-29.7,12.92-57.86,33.39-71,63-10.61,24-9.27,52.29,1.76,76a75.09,75.09,0,0,1-4.58,71.59C8.44,399.51-1.42,429.1.17,459.49c2.46,46.74,37.95,92.85,84.56,97.15,16,1.48,32.08-1.77,47.92-4.67,95.67-17.5,196.93-22,287.93,12.27,24.94,9.4,48.95,21.65,74.88,27.83,30.29,7.22,61.87,5.85,93,4.44,48.58-2.2,105.26-9,130.07-50.84,34.39-58-20.39-130.41-12.6-197.37,4.31-37,27.64-69.54,32.56-106.43,5.34-40.1-13.67-82.49-47.17-105.17-46.52-31.49-110.85-23.85-158.88-53-38-23.07-64.12-68.15-108.92-80.42C379.58-8.74,325.07,14,293.09,43.6Z",
    transform: "translate(0 0)",
    fill: "#0561fc",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.92,446.41c-4.7-32.27-15.91-63.34-20.45-95.64s-1.38-67.82,19.31-93c13.5-16.43,32.9-26.68,51.87-36.29,16.87-8.55,34.24-17.07,53-19.39,16.54-2,33.23.85,49.77,2.83,31.12,3.72,62.81,4.21,93.7-1.09,40.33-7,78.46-23,117.88-33.83,38.61-10.66,76.83-16.09,120,4,29.84,13.9,51.86,42.92,59,75,11.54,51.83-14.52,109.27,7.39,157.63,6.18,13.62,15.78,25.36,23.62,38.1a166.06,166.06,0,0,1,20.58,50.9c1.37,6.19,2.38,12.72.63,18.81-4.5,15.6-23.78,20.79-40,22.07-53.93,4.26-107.81-5.8-161.6-11.65-87.32-9.48-175.43-7.81-262.9-1.28q-32.11,2.4-64.18,5.6c-17.25,1.69-50,12-66.26,7.09-18.13-5.49-6.23-17.38-2.39-34.45C94,483.7,93.58,464.65,90.92,446.41Z",
    transform: "translate(0 0)",
    fill: "#0561fc",
    opacity: 0.11,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384,137.18s-8.27,33.62-20.63,43c-12.76,9.68-26-8.92-26-8.92L330,184.58s13.63,22,27.37,22.51,25.8-11.79,25.8-11.79Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "313.37 114.09 315.24 113.26 353.36 122.95 364.81 200.15 363.38 200.15 313.37 114.09",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.05,530.65s-83.15,5.57-95.11,13.54,81.7,9.72,231.15,5.23,264.52,0,346,8.22,192,6.63,193.53-13.5-201.75-20.37-201.75-20.37Z",
    transform: "translate(0 0)",
    fill: "#000405",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650,370.41s-2.79,23.22-20.73,25.5h-78.8L539.26,267h83c6.7,0,20.43,7.22,23.17,17.44a44.22,44.22,0,0,1,.73,5.73h0C648,310,650,370.41,650,370.41Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M757.18,124.86h-76l-22.56-22.15-1-1h75.7c6.7,0,20.43,7.22,23.17,17.44A45.64,45.64,0,0,1,757.18,124.86Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.22,279l-7.42-3.23a4.58,4.58,0,0,1,1.83-8.78H539.26a33,33,0,0,1,25.93,12.2,23.24,23.24,0,0,1,5,11c1.81,12.07.7,64.64.2,84.38-.27,10.72-8.17,20-18.81,21.28l-1.14.11h-389Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.22,279l-7.42-3.23a4.58,4.58,0,0,1,1.83-8.78H539.26a33,33,0,0,1,25.93,12.2,23.24,23.24,0,0,1,5,11c1.81,12.07.7,64.64.2,84.38-.27,10.72-8.17,20-18.81,21.28l-1.14.11h-389Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M570.42,374.52c-.27,10.72-8.17,20-18.81,21.28l-1.14.11h-389L143.22,279l-7.42-3.23a4.58,4.58,0,0,1,1.83-8.78H539.26a33,33,0,0,1,25.93,12.2,23.24,23.24,0,0,1,5,11C572,302.21,570.92,354.78,570.42,374.52Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.08,396h428.8a5.6,5.6,0,0,0,5.6-5.59h0a5.6,5.6,0,0,0-5.6-5.6H123.08a5.6,5.6,0,0,0-5.6,5.6h0A5.6,5.6,0,0,0,123.08,396Z",
    transform: "translate(0 0)",
    opacity: 0.61,
    fill: "url(#linear-gradient-3)",
    style: {
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.08,396h428.8a5.6,5.6,0,0,0,5.6-5.59h0a5.6,5.6,0,0,0-5.6-5.6H123.08a5.6,5.6,0,0,0-5.6,5.6h0A5.6,5.6,0,0,0,123.08,396Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M639.87,432.69v69.95a34.42,34.42,0,0,1-34.4,34.42H153.06a34.36,34.36,0,0,1-34.41-34.31h0V432.69a34.16,34.16,0,0,1,5.1-18,31.74,31.74,0,0,1,2.42-3.44,34.33,34.33,0,0,1,26.89-12.95h452.4a34.43,34.43,0,0,1,34.41,34.41h0Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M463.7,537.06H153.06A34.41,34.41,0,0,1,121.75,517H443.94S448.58,534,463.7,537.06Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M463.7,398.26c-14.28,2.36-18.27,16.39-18.27,16.39H123.75l2.42-3.44a34.33,34.33,0,0,1,26.89-12.95Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M639.87,432.69v69.95a34.38,34.38,0,0,1-17.79,30.14H480a21.6,21.6,0,0,1-21.61-21.59h0V426.31A21.6,21.6,0,0,1,480,404.7H625.5A34.38,34.38,0,0,1,639.87,432.69Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M639.87,432.69v69.95a35.52,35.52,0,0,1-.21,3.86c-.06.56-.14,1.11-.23,1.66a32.67,32.67,0,0,1-1.9,7c-.21.57-.44,1.12-.7,1.67a34.75,34.75,0,0,1-4.2,7c-.44.56-.9,1.12-1.39,1.66a34.44,34.44,0,0,1-9.16,7.35H500.41a21.51,21.51,0,0,1-16.23-7.35,19.22,19.22,0,0,1-1.32-1.66,21,21,0,0,1-3.31-7c-.15-.54-.27-1.1-.37-1.67a20.89,20.89,0,0,1-.37-3.95v-84.9a21.3,21.3,0,0,1,.48-4.5,13.41,13.41,0,0,1,.41-1.66,21.27,21.27,0,0,1,3.56-7,20.26,20.26,0,0,1,1.41-1.66,21.48,21.48,0,0,1,15.74-6.82H625.5a34.22,34.22,0,0,1,7.09,6.82c.42.54.83,1.09,1.22,1.66a33.26,33.26,0,0,1,3.7,7c.22.55.43,1.11.6,1.66a32.32,32.32,0,0,1,1.54,7c.07.55.12,1.11.15,1.67S639.87,432,639.87,432.69Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M639.87,432.69v69.95a35.52,35.52,0,0,1-.21,3.86c-.06.56-.14,1.11-.23,1.66a32.67,32.67,0,0,1-1.9,7c-.21.57-.44,1.12-.7,1.67a34.75,34.75,0,0,1-4.2,7c-.44.56-.9,1.12-1.39,1.66a34.44,34.44,0,0,1-9.16,7.35H500.41a21.51,21.51,0,0,1-16.23-7.35,19.22,19.22,0,0,1-1.32-1.66,21,21,0,0,1-3.31-7c-.15-.54-.27-1.1-.37-1.67a20.89,20.89,0,0,1-.37-3.95v-84.9a21.3,21.3,0,0,1,.48-4.5,13.41,13.41,0,0,1,.41-1.66,21.27,21.27,0,0,1,3.56-7,20.26,20.26,0,0,1,1.41-1.66,21.48,21.48,0,0,1,15.74-6.82H625.5a34.22,34.22,0,0,1,7.09,6.82c.42.54.83,1.09,1.22,1.66a33.26,33.26,0,0,1,3.7,7c.22.55.43,1.11.6,1.66a32.32,32.32,0,0,1,1.54,7c.07.55.12,1.11.15,1.67S639.87,432,639.87,432.69Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-7)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M633.81,413.18H483.26a20.26,20.26,0,0,1,1.41-1.66H632.58C633,412.06,633.42,412.61,633.81,413.18Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M638.11,421.81H479.29a13.41,13.41,0,0,1,.41-1.66H637.51C637.73,420.7,637.94,421.26,638.11,421.81Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M639.8,430.45h-161v-1.67H639.65C639.72,429.33,639.77,429.89,639.8,430.45Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 478.81,
    y: 437.42,
    width: 161.07,
    height: 1.66,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 478.81,
    y: 446.05,
    width: 161.07,
    height: 1.66,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 478.81,
    y: 454.69,
    width: 161.07,
    height: 1.66,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 478.81,
    y: 463.33,
    width: 161.07,
    height: 1.65,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 478.81,
    y: 471.96,
    width: 161.07,
    height: 1.65,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 478.81,
    y: 480.6,
    width: 161.07,
    height: 1.65,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 478.81,
    y: 489.23,
    width: 161.07,
    height: 1.65,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 478.81,
    y: 497.87,
    width: 161.07,
    height: 1.66,
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M639.66,506.5c-.06.56-.14,1.11-.23,1.66H478.81V506.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M637.58,515.13c-.21.57-.44,1.12-.7,1.67H479.58c-.15-.54-.27-1.1-.37-1.67Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M632.63,523.77c-.44.56-.9,1.12-1.39,1.66H484.18a19.22,19.22,0,0,1-1.32-1.66Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M440.26,382.13h102.5a31.2,31.2,0,0,1-14,3.28H147.64A30.58,30.58,0,0,1,130,380a26.82,26.82,0,0,1-4.07-3.45c-.4-.41-.79-.84-1.16-1.27a26.13,26.13,0,0,1-3.54-5.35c-.21-.42-.41-.85-.59-1.27a23.72,23.72,0,0,1-1.6-5.35c-.07-.42-.14-.84-.19-1.28a25.16,25.16,0,0,1-.18-3V305.37a16.29,16.29,0,0,1,.06-1.71c.06-.56.07-.85.12-1.27a24,24,0,0,1,1.29-5.35c.16-.43.33-.85.51-1.28a24.63,24.63,0,0,1,3.12-5.34l1-1.28a27.3,27.3,0,0,1,2.37-2.44,30.37,30.37,0,0,1,20.5-7.7H528.76a30.81,30.81,0,0,1,16.87,5H440.26a19.63,19.63,0,0,0-4.76.58,18.37,18.37,0,0,0-8.5,4.64,14.42,14.42,0,0,0-1.19,1.28,15.76,15.76,0,0,0-3,5.34,11.55,11.55,0,0,0-.35,1.28,14.85,14.85,0,0,0-.4,3.45v65.07a15.12,15.12,0,0,0,.31,3,11.24,11.24,0,0,0,.32,1.27,15.45,15.45,0,0,0,2.78,5.35,16.81,16.81,0,0,0,1.11,1.27,17.86,17.86,0,0,0,6.07,4.12A19.29,19.29,0,0,0,440.26,382.13Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M557.74,305.76v54.29a4.69,4.69,0,0,1-.06.92c-.06.3,0,.61-.08.91a5.12,5.12,0,0,0-.11.83c0,.27-.07.43-.11.64a1.65,1.65,0,0,1-.06.32c-.05.29-.11.59-.18.88s-.09.38-.15.57-.09.37-.15.56-.11.4-.17.6l-.21.61a1.41,1.41,0,0,1-.16.49c-.06.16-.16.43-.25.64l-.27.65a2.21,2.21,0,0,1-.16.35,4.31,4.31,0,0,1-.22.49c-.06.14-.14.28-.21.42s-.21.43-.33.63-.34.65-.53,1l-.31.5c-.28.46-.57.9-.88,1.33-.16.23-.32.44-.48.65-.32.43-.66.84-1,1.25s-.76.86-1.17,1.27a27.69,27.69,0,0,1-2.61,2.35.13.13,0,0,1-.07.06c-.3.24-.6.46-.91.69l-1,.69-1,.64c-.32.2-.64.38-1,.57l-1.15.61H440.26a19.5,19.5,0,0,1-7.61-1.51,18.05,18.05,0,0,1-6.07-4.1,16.81,16.81,0,0,1-1.11-1.27,15.32,15.32,0,0,1-2.78-5.32,10.56,10.56,0,0,1-.32-1.26,15.12,15.12,0,0,1-.31-3V300.89a14.62,14.62,0,0,1,.4-3.43,11.38,11.38,0,0,1,.35-1.27,15.62,15.62,0,0,1,3-5.31A14.42,14.42,0,0,1,427,289.6a18.62,18.62,0,0,1,8.5-4.62,20.12,20.12,0,0,1,4.76-.57H545.63c.46.3.92.61,1.36.94l.51.38a24.45,24.45,0,0,1,2,1.66l.55.52.4.4.54.56.54.6.11.13.08.1c.32.38.64.78.94,1.18.16.2.31.41.46.61a.16.16,0,0,0,.06.08q.41.58.78,1.17l.43.7c.26.44.51.9.74,1.35.11.24.23.46.34.69s.22.48.31.71.19.42.27.64.17.42.24.63l.22.63a20.39,20.39,0,0,1,.73,2.65,2,2,0,0,1,.07.35,3.5,3.5,0,0,0,.12.63c0,.21.11.71.16,1.06s.1.84.12,1.27v.68C557.71,305,557.74,305.41,557.74,305.76Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M432.65,380.61c-2.26.55-4.59,1.05-7,1.52H153.92A123.88,123.88,0,0,1,130,380a26.82,26.82,0,0,1-4.07-3.45c-.4-.41-.79-.84-1.16-1.27a26.13,26.13,0,0,1-3.54-5.35c-.21-.42-.41-.85-.59-1.27a23.72,23.72,0,0,1-1.6-5.35c-.07-.42-.14-.84-.19-1.28a25.16,25.16,0,0,1-.18-3V305.37a16.29,16.29,0,0,1,.06-1.71c.06-.56.07-.85.12-1.27a24,24,0,0,1,1.29-5.35c.16-.43.33-.85.51-1.28a24.63,24.63,0,0,1,3.12-5.34l1-1.28a27.3,27.3,0,0,1,2.37-2.44,122.55,122.55,0,0,1,26.8-2.75H433.26l2.24.58a18.37,18.37,0,0,0-8.5,4.64,14.42,14.42,0,0,0-1.19,1.28,15.76,15.76,0,0,0-3,5.34,11.55,11.55,0,0,0-.35,1.28,14.85,14.85,0,0,0-.4,3.45v65.07a15.12,15.12,0,0,0,.31,3,11.24,11.24,0,0,0,.32,1.27,15.45,15.45,0,0,0,2.78,5.35,16.81,16.81,0,0,0,1.11,1.27A17.89,17.89,0,0,0,432.65,380.61Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M432.65,380.61c-2.26.55-4.59,1.05-7,1.52H153.92A123.88,123.88,0,0,1,130,380a26.82,26.82,0,0,1-4.07-3.45c-.4-.41-.79-.84-1.16-1.27a26.13,26.13,0,0,1-3.54-5.35c-.21-.42-.41-.85-.59-1.27a23.72,23.72,0,0,1-1.6-5.35c-.07-.42-.14-.84-.19-1.28a25.16,25.16,0,0,1-.18-3V305.37a16.29,16.29,0,0,1,.06-1.71c.06-.56.07-.85.12-1.27a24,24,0,0,1,1.29-5.35c.16-.43.33-.85.51-1.28a24.63,24.63,0,0,1,3.12-5.34l1-1.28a27.3,27.3,0,0,1,2.37-2.44,122.55,122.55,0,0,1,26.8-2.75H433.26l2.24.58a18.37,18.37,0,0,0-8.5,4.64,14.42,14.42,0,0,0-1.19,1.28,15.76,15.76,0,0,0-3,5.34,11.55,11.55,0,0,0-.35,1.28,14.85,14.85,0,0,0-.4,3.45v65.07a15.12,15.12,0,0,0,.31,3,11.24,11.24,0,0,0,.32,1.27,15.45,15.45,0,0,0,2.78,5.35,16.81,16.81,0,0,0,1.11,1.27A17.89,17.89,0,0,0,432.65,380.61Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M550.47,386.11a24.64,24.64,0,0,1-2.61,2.6A27.85,27.85,0,0,0,550.47,386.11Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-10)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M553.09,292.23c-.15-.23-.3-.46-.46-.68-.3-.44-.62-.88-.94-1.3C552.19,290.89,552.66,291.55,553.09,292.23Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-11)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M556.26,298.82c.08.23.15.46.22.69-.13-.47-.29-.93-.46-1.39C556.11,298.35,556.19,298.58,556.26,298.82Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-12)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M557.74,305.76v54.89a7.46,7.46,0,0,1-.1,1.16,22.86,22.86,0,0,1-1.06,4.84c-.12.39-.25.77-.4,1.14a27.23,27.23,0,0,1-13.37,14.34H423.05c-9.24,0-16.87-6.24-18-14.32a7.48,7.48,0,0,1-.12-1.16,8.37,8.37,0,0,1-.05-1V300.89c0-9.11,8.14-16.48,18.2-16.48H545.63C553,289.17,557.74,297,557.74,305.76Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M552.63,290.42H425.81a14.42,14.42,0,0,1,1.19-1.28H551.58A11.71,11.71,0,0,1,552.63,290.42Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M556.26,297H422.46a11.55,11.55,0,0,1,.35-1.28h133C555.94,296.18,556.11,296.61,556.26,297Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M557.69,303.66H422.06v-1.28H557.58C557.58,302.8,557.66,303.23,557.69,303.66Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 309,
    width: 135.69,
    height: 1.28,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 315.62,
    width: 135.69,
    height: 1.28,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 322.24,
    width: 135.69,
    height: 1.28,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 328.87,
    width: 135.69,
    height: 1.27,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 335.49,
    width: 135.69,
    height: 1.27,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 342.11,
    width: 135.69,
    height: 1.27,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 348.73,
    width: 135.69,
    height: 1.27,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 355.35,
    width: 135.69,
    height: 1.28,
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M557.76,362v1.28H422.06V362Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M555.77,368.59c0,.43-.55.85-.59,1.28H422.69a11.4,11.4,0,0,1-.32-1.28Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M430.68,290.42H123.75l1-1.28H428.24C429.08,289.56,429.89,290,430.68,290.42Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M427.92,297H120.12c.16-.43.33-.85.51-1.28H426.71A14.64,14.64,0,0,1,427.92,297Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M431.32,303.66H118.71a9,9,0,0,1,.12-1.27H431A9.44,9.44,0,0,1,431.32,303.66Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 118.64,
    y: 309,
    width: 312.82,
    height: 1.27,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 118.64,
    y: 315.62,
    width: 312.82,
    height: 1.27,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 118.64,
    y: 322.24,
    width: 312.82,
    height: 1.28,
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 118.64,
    y: 328.87,
    width: 312.82,
    height: 1.27,
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 118.64,
    y: 335.5,
    width: 312.82,
    height: 1.26,
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 118.64,
    y: 342.11,
    width: 312.82,
    height: 1.26,
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 118.64,
    y: 348.73,
    width: 312.82,
    height: 1.27,
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 118.64,
    y: 355.35,
    width: 312.82,
    height: 1.28,
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M431,362a11.52,11.52,0,0,1-.47,1.28H119c-.07-.42-.14-.84-.19-1.28Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M426.75,368.6a18.79,18.79,0,0,1-1.41,1.27H121.21c-.21-.42-.41-.85-.59-1.27Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M442.37,267c-4.51,5.42-10.34,10.87-12.65,12.08C416.58,286,401.36,291.3,393.65,304c-9.76,16-3.45,36.93-7.93,55.15-.82,3.32-2.09,6.71-4.66,9s-6.7,3.07-9.43,1c-2.4-1.81-3-5.09-3.45-8.06a315.38,315.38,0,0,1-.44-84.55c-15,6.7-25.15,20.84-33.16,35.14s-14.73,29.63-25.89,41.64c-3.17,3.4-7.34,6.73-11.94,6.07-5.53-7-2.63-17.23.51-25.61C303.55,316.9,309.86,300,318,284c2.62-5.2,5.53-10.42,9.93-14.24a25.32,25.32,0,0,1,3.88-2.77Z",
    transform: "translate(0 0)",
    fill: "#3f3d56",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M551.64,375.22c-.34.45-.72.8-1.1,1.27H125.91c-.4-.41-.79-.84-1.16-1.27Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M217.78,537.06H166.47c-16.45-4.14-24.42-21.93-24.42-21.93s-1.49-87,0-98,26.41-18.9,26.41-18.9h49.32c-16.45,2.36-28.4,18.4-28.4,18.4s-1,96.15,0,102.62S217.78,537.06,217.78,537.06Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M217.78,537.06H201.33c-16.43-4.14-24.4-21.93-24.4-21.93s-1.5-87,0-98,26.4-18.9,26.4-18.9h14.45c-16.45,2.36-28.4,18.4-28.4,18.4s-1,96.15,0,102.62S217.78,537.06,217.78,537.06Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M217.78,537.06H201.33c-16.43-4.14-24.4-21.93-24.4-21.93s-1.5-87,0-98,26.4-18.9,26.4-18.9h14.45c-16.45,2.36-28.4,18.4-28.4,18.4s-1,96.15,0,102.62S217.78,537.06,217.78,537.06Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-14)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "289.24 329.8 284.46 338.1 295.56 342.93 300.15 335.03 289.24 329.8",
    fill: "url(#linear-gradient-15)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.87 352.09 363.35 361.34 375.45 360.64 375.96 352.09 363.87 352.09",
    fill: "url(#linear-gradient-16)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M286.64,336.26a4.2,4.2,0,0,0-1-1.33,3.7,3.7,0,0,0-1.64-.6l-19.21-3.86a8,8,0,0,0-2.12-.23c-1.84.12-3.35,1.47-4.56,2.86a4.15,4.15,0,0,0-1.26,2.48,4.33,4.33,0,0,0,1.76,3,49.28,49.28,0,0,0,4.25,3.52,88.77,88.77,0,0,0,8.87,5.47c2.06,1.16,4.12,2.32,6.23,3.38,3.47,1.74,7.07,3.2,10.69,4.62a1.06,1.06,0,0,0,1.46-.34h0a29.27,29.27,0,0,0,6.08-9.46c.35-.87,1-2.78,0-3.5-.35-.25-1.34-.21-1.78-.31a12.5,12.5,0,0,1-7.78-5.69Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M364.58,357.14a4.42,4.42,0,0,0-1.53-.65,3.89,3.89,0,0,0-1.72.3l-18.54,6.33a8.06,8.06,0,0,0-2,.86c-1.53,1-2.16,3-2.51,4.77a4.06,4.06,0,0,0,.17,2.77,4.29,4.29,0,0,0,3,1.69,45.37,45.37,0,0,0,5.44.9,86.12,86.12,0,0,0,10.41.27c2.37,0,4.73-.06,7.09-.21,3.88-.24,7.73-.79,11.56-1.38a1.06,1.06,0,0,0,1.1-1,29.55,29.55,0,0,0,.51-11.24c-.14-.93-.57-2.89-1.78-3-.43-.05-1.26.49-1.69.62a11.29,11.29,0,0,1-2,.42A12.43,12.43,0,0,1,364.58,357.14Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.4,90",
    transform: "translate(0 0)",
    fill: "#0561fc",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M439.64,232.4s-3.14,29.39-30.23,34.6c-18.34,3.51-40.77,2.26-53.33,1.09a16.17,16.17,0,0,0-15.16,7.47l-39,62.12-11.3-5.46h-.09l-4-1.92L319,254.49a34.31,34.31,0,0,1,21.62-19.88l37.31-11.55,8.72-2.7S421.58,216.84,439.64,232.4Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378,223l2.45,5.19s-43,12.6-48.28,18.73c-7.05,8.2-41.51,85.25-41.51,85.25h-.09l-4-1.92L319,254.49a34.31,34.31,0,0,1,21.62-19.88Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M393.24,227.3S358.7,261,357.58,279s3.71,74.44,3.71,74.44h16.76s-.83-68.52,6-69S421.84,264,426.81,258.3s12.9-25.92,12.9-25.92Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M439.64,232.4S412,246.53,383.2,230a64.56,64.56,0,0,1-7.21-4.81s12.12-21.65,2.47-53.1c-4.13-13.45-4.22-39.13,16.23-42.79h.1c20.34-3.61,19.19,1.41,19.19,1.41l9.2,8.94C440.87,154,442.81,176,439.64,232.4Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.79,129.28a11.65,11.65,0,0,1-3.83,4.63s-12.16,5.39-9.73,23.22,6.88,52.12,6.88,52.12L383.2,230a64.56,64.56,0,0,1-7.21-4.81s12.12-21.65,2.47-53.1c-4.13-13.45-4.22-39.13,16.23-42.79Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M413.08,128.14a12.72,12.72,0,0,1-17.92,1.59h0l-.44-.38s-15,15,.16,16.81c8,1,17.85-8.68,20.7-14.15Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M417.58,114.09c-.06.2-2.88,8.83-5,15a20,20,0,0,1-9.34,11.29,22.24,22.24,0,0,1-8.5,3,3.92,3.92,0,0,1-4.26-3.55h0a3.87,3.87,0,0,1,.53-2.35c.7-1.23,1.46-2.65,2.16-4.16,1.46-3.14,2.68-6.63,2.48-9.39v-.3c-.18-1.44.76-2.71,2.34-3.82,2.23-1.55,5.74-2.77,9.17-3.69A94.44,94.44,0,0,1,417.58,114.09Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-17)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M395.35,133.2a8.15,8.15,0,0,1-2.09.15c1.46-3.14,2.68-6.63,2.48-9.39l2.32-4.12,1.73-3.06,7.44-.63,7.52-.63C409.79,127.25,401.46,132.11,395.35,133.2Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-18)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M409.32,74.63a20.17,20.17,0,0,0-23.87,15.6c-.1.51-.19,1-.26,1.55a68.27,68.27,0,0,0-.19,24.48c3.43,12.55,21.86,8,25.6,4.19s18.77-21.37,16.31-28.2C425.34,87.61,419.84,77,409.32,74.63Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-19)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M394.47,62.39,397.31,65a12.83,12.83,0,0,0-11.5,2.17,16.82,16.82,0,0,0-7.81,10l6.31-1.13s-2.3,6.79,8.16,10.18S414,93.1,414,93.1l-2.24-6s5.87,4.42,6.36,7.18a83.06,83.06,0,0,1-1,12.5s4.48-6.1,5.16-4.32-3.22,7.35-5,8.34-2.62,5.1-2.84,5.4,8-3.44,8.81-5.28S436,91.57,432.72,86.33l2.69.51a13.14,13.14,0,0,0-4.66-3.42S419.58,56,394.47,62.39Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M390.51,210.05c-1.51-1.51-3-3.31-5.11-3.67-.74,1.76.77,3.57,1.41,5.36a1.44,1.44,0,0,1,0,1.28c-.3.48-1,.51-1.55.47a24.35,24.35,0,0,1-7.75-1.86c-2.28-1-4.47-2.29-6.94-2.54a1.24,1.24,0,0,0-.78.1c-.6.38-.25,1.3.18,1.86a21.66,21.66,0,0,0,3.11,3.31,17.16,17.16,0,0,0-5.5-1.41c-.53,0-1.25.11-1.24.64a1,1,0,0,0,.3.57,17,17,0,0,0,5,3.92,16.92,16.92,0,0,0-4.2-.35c-.61,0-1.42.32-1.33.92a1,1,0,0,0,.28.52,12.76,12.76,0,0,0,6.54,4.19l-4,.09a1.55,1.55,0,0,0-.73.15c-.72.46-.09,1.59.61,2.08,3.08,2.15,7,2.53,10.77,2.8,7.21.52,14.8.8,21.3-2.38.47-.24,1-.56,1.09-1.08a1.82,1.82,0,0,0-.12-.8c-.79-2.63-1.19-7.4-3.58-9-1.16-.77-2.59-1.21-3.78-2S391.87,210.73,390.51,210.05Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-20)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M445.51,204.47C443.25,226.68,403,229.4,403,229.4l-4.15-14.27-.73-2.51s21.56-2.72,25.68-9.47-12.84-29.38-2.59-42,12.58-8.74,12.58-8.74S447.75,182.26,445.51,204.47Z",
    transform: "translate(0 0)",
    fill: "#0561fc"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M337.39,171.27a16.06,16.06,0,0,1-.17,2.08c-.34,3.11-1.31,8.8-3.89,10.87-3.63,2.91-4.13-1.33-4.05-3a17.74,17.74,0,0,1,.45-2.72c.84-3.62,5.29-6.1,7-6.92Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-21)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M337.22,173.35c-.34,3.11-1.31,8.8-3.89,10.87-1.12-.81-2.56-1.89-4.05-3-2-1.5-4.13-3.08-5.64-4.18a19,19,0,0,1-3.64-3.18,18.14,18.14,0,0,1-2.32-4l-3.1-6.74c-1-2.21-2-5.13-.22-6.84.45-.44,4.55-1.24,4.82-1.82.75-1.66-4-5.17-3.7-7a2.23,2.23,0,0,1,2.37-1.58c1,.05,3.84,2.66,4.73,3.19,1.76,1,.28,2.42,2,3.46a22.82,22.82,0,0,1,6,4.46c1.94,2.27,2.92,5.18,3.85,8,.68,2.07,1.59,4.31,2.29,6.54C336.91,172.17,337.08,172.76,337.22,173.35Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-22)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.51 157.41 315.84 125.78 313.37 114.09 352.13 124.48 363.38 200.15 327.36 189.17 322.51 157.41",
    fill: "#0561fc"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.58 157.03 315.24 122.95 327.36 189.17 363.38 200.15 359.52 174.2 330.58 157.03",
    fill: "url(#linear-gradient-23)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M324.72,171.05c1.22-.61,3.72-1.72,4.35-2.93.15-.29.37-.67.18-.93-.87-1.2-4.45.33-5.47,0,.7-1.15,6.94-4.64,4-5.43-.63-.17-4.54,1.81-5.17,1.63.49-.4,4.51-3.26,5.2-4a1.31,1.31,0,0,0-1.47-2.09,61.12,61.12,0,0,1-6.54,2.56c.43-.71,6.24-4,6.47-4.84a1.56,1.56,0,0,0,.06-1,1.38,1.38,0,0,0-.85-.75c-1.62-.63-3.44,0-5.06.65l-3.84,1.52c-1.23.48-2.59,1.1-3,2.34a4.2,4.2,0,0,0-.09,1.93A25.16,25.16,0,0,0,317.7,171c1.14,1.66,4.74,5.67,6.81,6.06C326.35,177.41,323,172,324.72,171.05Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-24)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,273.56s13.22-30.29,28.5-38.91l-5.21-2.11s-26.83,28.53-30,43.21,3.19,77.67,3.19,77.67h4.4S358.43,279.74,364.82,273.56Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.92,208c-8.51,3.5-23,6.55-26.12,7.19l-.6.12-.13-2.63s21.56-2.72,25.68-9.47-12.84-29.38-2.59-42c0,0-1.3,11.16,2.07,19.41S434.48,204,424.92,208Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationDarkb);
export default __webpack_public_path__ + "static/media/education_darkb.3140d0c8689dc0bc769ca74d281b3a35.svg";
export { ForwardRef as ReactComponent };